import { lazyPipe, validateApiResponse, withApiErrorCapture } from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { profileApiPath } from './apiPath';

const GetNicknameRecommendationResponseDataSchema = z
  .object({
    nickname: z.string(),
  })
  .describe('GetNicknameRecommendationResponseDataSchema');

const GetNicknameRecommendationResponseSchema = createApiResponseSchema(
  GetNicknameRecommendationResponseDataSchema,
);

type GetNicknameRecommendationResponse = z.infer<typeof GetNicknameRecommendationResponseSchema>;

export const getNicknameRecommendation = withApiErrorCapture(
  lazyPipe(
    () =>
      executeStandardRequest(async () =>
        privateHttpClient.get<GetNicknameRecommendationResponse>(
          profileApiPath.getNicknameRecommendation,
        ),
      ),
    validateApiResponse(GetNicknameRecommendationResponseSchema),
  ),
);
